import network from '@/services/network';

/**
 * Prozessdoku fuer Admins (docs/tasks/prozessdoku-admin-ui.md).
 *
 * Nur Lesen. Die Repo-Datei `docs/PROZESSE-ADMIN.md` ist die einzige Quelle —
 * es gibt bewusst keinen Schreib-Endpunkt, keinen Upload und keine Suche.
 */
export interface ProzessKapitel {
  /** Anker im gerenderten HTML, z. B. `kapitel-3`. */
  id: string;
  titel: string;
}

export interface Prozessdoku {
  titel: string | null;
  /**
   * Datei-Datum der Quelle (ISO). Bewusst NICHT "zuletzt inhaltlich
   * geaendert": eine Deploy-Nummer gibt es in der App nicht.
   */
  dateistand: string;
  kapitel: ProzessKapitel[];
  /** Serverseitig gerendertes, von rohem HTML bereinigtes Markdown. */
  html: string;
}

const get = async (): Promise<Prozessdoku> => {
  const { data } = await network.get<Prozessdoku>('/prozessdoku');
  return data;
};

export default { get };
